import React from 'react';
import { graphql, useFragment, type PreloadedQuery } from 'react-relay';
import type { JQLBuilderProps } from '@atlassian/jira-jql-builder/src/common/types.tsx';
import JQLBuilder from '@atlassian/jira-jql-builder/src/main.tsx';
import type { JQLBuilderWithAIFilters$key } from './__generated__/JQLBuilderWithAIFilters.graphql';
import type { JQLBuilderWithAIFilterRefinementQuery } from './filter-refinement/__generated__/JQLBuilderWithAIFilterRefinementQuery.graphql';
import { JQLBuilderWithAIFilterRefinement } from './filter-refinement/JQLBuilderWithAIFilterRefinement.tsx';

export type Props = Omit<JQLBuilderProps, 'userPreferencesData'> & {
	fragmentKey: JQLBuilderWithAIFilters$key | null;
	isFilterRefinementEnabled?: boolean;
	/**
	 * Preloaded query reference for the filter refinement component.
	 */
	filterRefinementQueryReference?: PreloadedQuery<JQLBuilderWithAIFilterRefinementQuery> | null;
};

export const JQLBuilderWithAIFilters = ({
	fragmentKey,
	isFilterRefinementEnabled,
	projectContext,
	...props
}: Props): React.JSX.Element => {
	const { jqlMessages } = props;
	const data = useFragment<JQLBuilderWithAIFilters$key>(
		graphql`
			fragment JQLBuilderWithAIFilters on JiraQuery {
				userPreferences(cloudId: $cloudId) @optIn(to: "JiraUserPreferences") {
					...main_jqlBuilder_JQLBuilder
				}
			}
		`,
		fragmentKey,
	);

	if (!isFilterRefinementEnabled) {
		return <JQLBuilder {...props} userPreferencesData={data?.userPreferences ?? null} />;
	}

	const { query, onSearch, beforeControls, filterRefinementQueryReference, onReset } = props;

	return (
		<>
			{filterRefinementQueryReference && (
				<JQLBuilderWithAIFilterRefinement
					defaultJql={query}
					onSearch={onSearch}
					beforeControls={beforeControls}
					filterRefinementQueryReference={filterRefinementQueryReference}
					projectContext={projectContext}
					onReset={onReset}
					jqlMessages={jqlMessages}
				/>
			)}
		</>
	);
};
